import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const providerHighlightApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHighlights: builder.query({
      query: () => {
        return 'provider_highlight/';
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetHighlightsQuery} = providerHighlightApi;
